/************************************************************************************
  The Prince Learning Portal Configuration
*************************************************************************************/

export const config = {
  // Keep the Prince portal scoped correctly for local, development, and
  // production Cognito pools; their IDs are deployment-specific.
  userPoolScope: "steyvers" as const,
  styledText: "The Prince Learning Portal",
  applicationName: "The Prince Digital Companion",
  companyName: "Steyvers",
  shortName: "TP",
  appName: "The Prince Learning Portal",
  showHomeTab: false,
  showAdminTabs: false,
  showConversationResults: false,
  showCompanionSettings: false,
  showResponseLengthOnly: false,
  showNewChatButton: false,
  showGoalChecklist: true,
  hideChatToolsForUsersOnly: true,
  // "About The Prince" and "Activities to Try" removed from the bottom nav
  // per Nick's request. The routes/pages behind them (/learn/about,
  // /learn/activities) are left in place, just no longer linked from here.
  // Explicit element type: an untyped empty array literal infers as
  // never[], which breaks LearningSidebar's .map() over this field.
  customTabs: [] as Array<{ label: string; path: string; icon: string }>,
  applicationSummary:
    "The Prince Learning Portal is an interactive guide to Niccolò Machiavelli's political writings.",
  learningPersonaId: process.env.REACT_APP_LEARNING_PERSONA_ID || 'pde3d031ed24',
  // The persona is listed as "The Prince"; in captions and the transcript the speaker is Giacomo.
  avatarSpeakerName: 'Giacomo',
  // Steady two-line captions on this portal only; other portals keep the default caption.
  steadyCaptions: true,
  // The portrait is framed tightly; cover crops his head/face in wide panes, so show the whole frame.
  avatarVideoFit: 'contain' as const,
  avatarVideoBackground: '#2a1d12',
  prodHostnames: [
    process.env.REACT_APP_PROD_HOSTNAME,
    "d3e29b4kg2715r.cloudfront.net",
    "machiavelli.elder-wisdom.innovation.uci.edu",
  ].filter(Boolean) as string[],
  devHostnames: [
    process.env.REACT_APP_DEV_HOSTNAME,
    "d3ki2vk2565o1f.cloudfront.net",
    "machiavelli.elder-wisdom-dev.innovation.uci.edu",
  ].filter(Boolean) as string[],
};

export const exampleQuestions = [
  "What is the central argument of The Prince?",
  "What does virtù mean in Machiavelli's writing?",
  "How does fortune shape political power?",
  "Is it better for a ruler to be loved or feared?",
];

// Fallback Cognito parameters specific to The Prince if env vars are unset
const rawWebUrl = process.env.REACT_APP_WEB_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:3002");
const webUrl = rawWebUrl.endsWith('/') ? rawWebUrl : `${rawWebUrl}/`;

export const awsConfig = {
  REGION: process.env.REACT_APP_REGION || "us-west-2",
  USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID || "us-west-2_PrinceDefaultPool",
  USER_POOL_APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_APP_CLIENT_ID || "princeclientidfallback",
  API_URL: (process.env.REACT_APP_API_URL || "https://api.prince.avatar.platform").replace(/\/+$/, ''),
  WEB_URL: webUrl,
  AUTH_DOMAIN: (process.env.REACT_APP_AUTH_DOMAIN || "auth.prince.avatar.platform").replace(/^https?:\/\//, ''),
};
